enum UserRole {
  user = 'user',
  admin = 'admin',
  manager = 'manager',
  veterinary = 'veterinary'
}

export default UserRole;
